import { createBrowserRouter, RouterProvider } from "react-router-dom";
//@ts-expect-error This is part of vite-pages-plugin, and doesn't play well with TS
import routes from "~react-pages";
import "@/assets/Inter-3.19/inter.css";
import "@WahooFitness/redesignr/Fonts/RBNo3.1/index.css";
import "@WahooFitness/redesignr/Fonts/RBNo2.1a/index.css";
import "@/assets/fonts.css";
import "@/services/chartSetup";
import { I18nProvider } from "./contexts/I18nContext";
import WahooOfflineMFE from "@WahooFitness/wahoo-offline-mfe/WahooOfflineMFE";
import { WarmingUp } from "@WahooFitness/wahoo-offline-mfe";
import { getEnvironmentConfig } from "./services/getEnvironmentConfig";
import { FitnessAppsContextProvider } from "./contexts/FitnessAppsContext";
import { SharedMapProvider } from "@/contexts/SharedMapContext";
import { UnitFormatterProvider } from "@/contexts/UnitFormatterContext";
import { wahooLinkTransform } from "./services/wahooLinkTransform";
import { SWRConfig } from "swr";
import { extendCacheWithWorkoutDetailsLru } from "@/services/workoutDetailsSwrCache";
import { getInitialRouteTheme } from "@/services/getInitialRouteTheme";
import { useEffect } from "react";

// Above WahooOfflineMFE so every SWR hook in the app — including the
// user/subscription sources inside the offline MFE — shares one cache:
// pull-to-refresh's bound mutate(() => true) only reaches hooks mounted under
// this config, and the LRU bound on workout-details entries must cover every
// fetch site.
const ROOT_SWR_CONFIG = { provider: extendCacheWithWorkoutDetailsLru };

const initialRouteTheme = getInitialRouteTheme();

function App() {
  const myRoutes = createBrowserRouter(routes);

  useEffect(() => {
    if (window.parent !== window) {
      window.parent.postMessage({ channel: "mounted" }, "*");
    }
  }, []);

  return (
    <SWRConfig value={ROOT_SWR_CONFIG}>
      <WahooOfflineMFE
        stagingEnvironment={getEnvironmentConfig("staging")}
        productionEnvironment={getEnvironmentConfig("production")}
        devEnvironment={import.meta.env}
        wahooLinkTransform={wahooLinkTransform}
        theme={initialRouteTheme}
      >
        <I18nProvider>
          <UnitFormatterProvider>
            <FitnessAppsContextProvider>
              <SharedMapProvider>
                <RouterProvider
                  router={myRoutes}
                  fallbackElement={<WarmingUp />}
                  future={{ v7_startTransition: true }}
                />
              </SharedMapProvider>
            </FitnessAppsContextProvider>
          </UnitFormatterProvider>
        </I18nProvider>
      </WahooOfflineMFE>
    </SWRConfig>
  );
}

export default App;
